(function(){
  var st=document.createElement('style');
  st.textContent='@keyframes rppulse{0%,100%{transform:scale(1)}50%{transform:scale(1.12)}}';
  (document.head||document.documentElement).appendChild(st);
  function handle(){var p=location.pathname;var i=p.indexOf('/products/');if(i<0)return '';var s=p.slice(i+10);var j=s.indexOf('/');if(j>-1)s=s.slice(0,j);var q=s.indexOf('?');if(q>-1)s=s.slice(0,q);return s;}
  function seed(h){var s=0;for(var i=0;i<h.length;i++){s=(s*31+h.charCodeAt(i))%100000;}return s;}
  function findForm(){var fs=document.querySelectorAll('form');for(var i=0;i<fs.length;i++){var a=fs[i].getAttribute('action')||'';if(a.indexOf('/cart/add')>-1)return fs[i];}return null;}
  function stockFor(sd){
    var start=3+(sd%4);
    var drop=2+(Math.floor(sd/10)%2);
    var target=start-drop;if(target<1)target=1;
    var d=new Date();var hr=d.getHours()+d.getMinutes()/60;
    var p=(hr-9)/10;if(p<0)p=0;if(p>1)p=1;
    var v=Math.round(start-(start-target)*p);
    if(v<1)v=1;if(v>6)v=6;
    return v;
  }
  function selSize(){
    var vp=document.querySelector('variant-picker');
    if(!vp)return '';
    var r=vp.querySelector('input:checked');
    if(r){var v=r.value||r.getAttribute('value')||'';if(v)return String(v).trim();}
    var s=vp.querySelector('[aria-checked=true]');
    if(s)return (s.textContent||'').trim();
    return '';
  }
  function curSeed(){var sz=selSize();return seed(handle()+(sz?('::'+sz):''));}
  function render(){var l=document.getElementById('rp-left');if(!l)return;l.textContent='Only '+stockFor(curSeed())+' left';}
  function priceAnchor(){
    var vp=document.querySelector('variant-picker');
    var ps=[];var list=document.querySelectorAll('.price');
    for(var i=0;i<list.length;i++){var e=list[i];if(e.offsetParent!==null&&(e.textContent||'').indexOf('$')>-1)ps.push(e);}
    if(vp){var vt=vp.getBoundingClientRect().top;var f=[];for(var k=0;k<ps.length;k++){if(ps[k].getBoundingClientRect().top<vt)f.push(ps[k]);}ps=f;}
    if(!ps.length)return null;
    ps.sort(function(a,b){return b.getBoundingClientRect().top-a.getBoundingClientRect().top;});
    return ps[0];
  }
  function addShip(){
    if(document.getElementById('rp-ship'))return;
    var a=priceAnchor();if(!a)return;
    var block=a;var steps=0;
    while(steps<3&&block.parentNode&&block.parentNode!==document.body&&getComputedStyle(block).display.indexOf('inline')===0){block=block.parentNode;steps++;}
    var ship=document.createElement('div');
    ship.id='rp-ship';
    ship.setAttribute('style','font-size:14px;color:#16a34a;font-weight:700;margin-top:8px;');
    ship.textContent='Free shipping';
    block.parentNode.insertBefore(ship,block.nextSibling);
  }
  function addInd(){
    if(document.getElementById('rp-stock'))return;
    var form=findForm();if(!form)return;
    var h=handle();if(!h)return;
    var box=document.createElement('div');box.id='rp-stock';
    box.setAttribute('style','display:flex;align-items:center;gap:11px;flex-wrap:wrap;margin:14px 0;font-size:14.5px;color:#111;line-height:1.2;');
    var dot=document.createElement('span');
    dot.setAttribute('style','width:7px;height:7px;border-radius:50%;background:#111;display:inline-block;flex:0 0 auto;');
    var pop=document.createElement('span');
    pop.setAttribute('style','font-weight:700;');
    pop.textContent='Popular right now';
    var sep=document.createElement('span');
    sep.setAttribute('style','color:#cfcfcf;');
    sep.textContent='|';
    var left=document.createElement('span');left.id='rp-left';
    left.setAttribute('style','font-weight:800;color:#d92d20;display:inline-block;animation:rppulse 1.4s ease-in-out infinite;');
    left.textContent='Only '+stockFor(curSeed())+' left';
    box.appendChild(dot);box.appendChild(pop);box.appendChild(sep);box.appendChild(left);
    var picker=document.querySelector('variant-picker');
    var anchor=picker||form;
    if(anchor&&anchor.parentNode){anchor.parentNode.insertBefore(box,anchor);}
  }
  function apply(){addShip();addInd();}
  function burst(){apply();setTimeout(apply,300);setTimeout(apply,800);setTimeout(apply,1500);}
  if(document.readyState!=='loading')burst();else document.addEventListener('DOMContentLoaded',burst);
  document.addEventListener('shopify:section:load',burst);
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-picker'))render();},true);
  document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-picker'))setTimeout(render,60);},true);
  setInterval(apply,1200);
  setInterval(render,60000);
})();
